import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import upsertScheduleRulesetPayload from './model/request/upsertScheduleRulesetPayload';
import patchRuleset from 'Api/schedule-ruleset/patchRuleset';

const usePatchScheduleRuleset = () => {
  const { t } = useTranslation('schedule-ruleset');
  const queryClient = useQueryClient();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();

  return useMutation({
    mutationFn: async ({ formData, id }) => {
      onShowLoader({ variant: 'loader-primary' });

      const payload = upsertScheduleRulesetPayload(formData);

      return await patchRuleset({ payload, id });
    },
    onSuccess: (response) => {
      onResetToast();
      queryClient.invalidateQueries({ queryKey: ['ruleset-list'] });
      queryClient.invalidateQueries({ queryKey: ['ruleset-detail-generate', response.scheduleRuleset?.id] });

      onOpenToast({
        status: 'success',
        description: t('changesSavedSuccess'),
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : t('saveErrorDescription');
      onResetToast();

      onOpenToast({
        status: 'error',
        title: t('errorToastTitle'),
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePatchScheduleRuleset;